import './CopyDocumentExecutor.scss';
import React from 'react';
import { useNavigate } from 'react-router';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { ICopyDocumentExecutorProps } from './ICopyDocumentExecutorProps';
import { RouteNames } from '@/router/router.types';

export const CopyDocumentExecutorModal: React.FC<ICopyDocumentExecutorProps> = (props: ICopyDocumentExecutorProps) => {
    const navigate = useNavigate();

    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new DocumentExecutionService(props.docId).copyDocument(props.actionKey),
        onSuccess: (result) => {
            if (result.data) {
                navigate(RouteNames.DOCUMENT.replace(':id', result.data));
                props.completeHandler && props.completeHandler(true);
            }
        },
    });

    const messageBoxProp: IMessageDialogProps = {
        header: props.title,
        message: props.message,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} loading={isBusy} />;
};
